export const PERMS = {
    READ: 'report_driver_hourly_overview.read',
    EXPORT: 'report_driver_hourly_overview.export',
}
